
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: Storytelling
* Copyright IBM Corp. 2017, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'story': '스토리',
	'noDashboardFound': '스토리를 검색할 수 없습니다. 더 이상 존재하지 않거나 볼 수 있는 충분한 권한이 없습니다.',
	'noDashboardCapability': '스토리를 사용할 기능이 없습니다.',
	'noDashboardPermision': '이 스토리를 볼 수 있는 충분한 권한이 없습니다.',
	'defaultName': '새 스토리',
	'storyProperties': '스토리 특성',
	'createAvDataStoryLabel': '스토리',
	'createAvSlideShowLabel': '슬라이드쇼',
	'createAvPanAndZoomLabel': '안내된 여행',
	'dashboard_save_success': '스토리가 저장되었습니다.',
	'cmEmptySelection': '스토리가 삭제되었습니다. 새 스토리로 저장하십시오.',
	'createStoryTitle': '스토리 작성',
	'transitionStyleTitle': '전이 스타일',
	'createButton': '작성',
	'cancelButton': '취소',
	'dashboardResetTitle': '스토리 재설정',
	'dashboardResetMessage': '이 스토리에 적용된 모든 변경사항을 재설정하시겠습니까?',
	'dashboardResetToast': '스토리가 재설정되었습니다.',
	'filter_drag_and_drop_all_tabs': '모든 장면을 필터링하려면 데이터를 여기에 끌어서 놓으십시오.',
	'filter_drag_and_drop_current_tab': '이 장면을 필터링하려면 데이터를 여기에 끌어서 놓으십시오.',
	'filterIconLabel_Global': '모든 장면',
	'filterIconLabel_Tab': '이 장면',
	'filterIconTooltip_Global': '모든 장면',
	'filterIconTooltip_Tab': '이 장면',
	'filterOverflowMenu_Global': '모든 장면 오버플로우 메뉴',
	'filterOverflowMenu_Tab': '이 장면 오버플로우 메뉴',
	'renameScene': '장면 이름 바꾸기',
	'duplicateScene': '장면 복제',
	'deleteScene': '장면 삭제',
	'editTimelineHighlight': '강조표시 편집',
	'deleteTimelineHighlight': '강조표시 삭제',
	'filter_includesAll': '모두 포함',
	'timeline_highlight_moved_to': '타임라인 강조표시 %{id}이(가) %{time}(으)로 이동됨',
	'filter_tooltip': '[%{title}] - %{description}',
	'selectLabel': '선택',
	'newDefaultStoryName': '스토리: %{modelName}',
	'exportLabel': '저장',
	'exportAsLabel': '다른 이름으로 저장:',
	'exportDialogTitle': '스토리로 저장',
	'exportDialogFooter': '저장 및 취소 단추',
	'loadAfterExportLabel': '저장 후 스토리 열기',
	'selectTemplateLabel': '템플리트 선택',
	'outOfBoundsWarningMessage': '일부 대시보드 위젯은 그리드 외부에 있으며 내보내기 후에 올바르게 표시되지 않을 수 있습니다.',
	'emptyExploreCardsWarningMessage': '스토리로 저장 중에 비어 있는 카드가 삭제되었습니다.',
	'dashboard_export_success': '대시보드가 스토리로 저장되었습니다.',
	'explore_export_success': '탐색이 스토리로 저장되었습니다.',
	'toastUpgradeDone': '스토리가 업그레이드되었습니다. 최적 성능을 유지하려면 지금 저장하십시오.',
	'navigationMarker': '탐색 마커',
	'navigateMarkers': '탐색 마커',
	'navNextMarker': '다음 마커',
	'navPrevMarker': '이전 마커',
	'navPrevMarkerAbbreviated': '이전 마커',
	'timelineSettingsButton': '재생 옵션',
	'autoPlay': '모든 장면 재생',
	'loop': '루프',
	'refreshData': '시작 시 새로 고치기',
	'slideshowLabel': '슬라이드 쇼',
	'panAndZoomLabel': '안내된 여행',
	'slideShowLayoutLabel': '슬라이드 쇼 레이아웃',
	'panAndZoomLayoutLabel': '안내된 여행 레이아웃',
	'panAndZoomLayoutFooter': '안내된 여행 레이아웃은 단일 캔버스에 있는 장면의 콜렉션입니다. 이 스토리 유형을 실행할 때 프리젠테이션은 각 개별 장면을 순차적으로 확대/축소 및 이동합니다. 이는 각 장면이 새 캔버스에 표시되는 슬라이드 쇼 레이아웃과 다릅니다. 선으로 연결된 세 장면의 안내된 여행 레이아웃을 사용하면 장면의 가로 시퀀스를 작성할 수 있습니다. 이는 타임라인 표시에 유용합니다.',
	'PanAndZoomLayout1': '직사각형으로 배열된 5개 장면',
	'PanAndZoomLayout2': '왼쪽에서 오른쪽으로 올라가는 계단형으로 배열된 4개 장면',
	'PanAndZoomLayout3': '직사각형으로 배열된 6개 장면',
	'PanAndZoomLayout4': '맨 위에 6개의 작은 장면이 있고 맨 아래에 하나의 큰 장면이 있는, 직사각형으로 배열된 7개 장면',
	'PanAndZoomLayout5': '맨 위에 2개의 작은 장면과 맨 아래에 하나의 큰 장면으로 배열된 3개 장면',
	'PanAndZoomLayout6': '4개의 연속 장면이 수평 배치됨',
	'pageSelectWarning': '장면을 선택하십시오.',
	'noSceneTransitionLabel': '없음',
	'sceneTransitionPropertyLabel': '장면 전환',
	'animatedPathSceneTransitionLabel': '애니메이션 경로',
	'sweepSceneTransitionLabel': '스윕',
	'storyTypeLabel': '스토리 유형',
	'layoutLabel': '레이아웃',
	'tabName_animation': '애니메이션',
	'propAniAnimation': '애니메이션',
	'propAniTypeEntrance': '시작 애니메이션',
	'propAniDirectionIn': '시작 방향',
	'propAniTypeExit': '종료 애니메이션',
	'propAniDirectionOut': '종료 방향',
	'propAniDirection': '방향',
	'propAniEntrance': '시작',
	'propAniTypeEntranceSlideIn': '슬라이드 인',
	'propAniTypeEntranceFadeIn': '페이드 인',
	'propAniTypeEntrancePivotIn': '피벗 인',
	'propAniTypeEntranceScaleIn': '배율 축소',
	'propAniTypeEntranceShrinkIn': '축소',
	'propAniDirectionInLeft': '왼쪽에서',
	'propAniDirectionInRight': '오른쪽에서',
	'propAniDirectionInTop': '맨 위에서',
	'propAniDirectionInBottom': '맨 아래에서',
	'propAniExit': '종료',
	'propAniTypeExitSlideIn': '슬라이드 아웃',
	'propAniTypeExitFadeIn': '페이드 아웃',
	'propAniTypeExitPivotOut': '피벗 아웃',
	'propAniTypeExitScaleIn': '배율 확장',
	'propAniTypeExitExpandOut': '확장',
	'propAniDirectionOutLeft': '왼쪽으로',
	'propAniDirectionOutRight': '오른쪽으로',
	'propAniDirectionOutTop': '맨 위로',
	'propAniDirectionOutBottom': '맨 아래로',
	'propAniEntranceTime': '시작 시간(초):',
	'propAniExitTime': '종료 시간(초):',
	'animationNoEntranceText': '위젯이 장면의 시작 부분에 있으면 시작 애니메이션이 발생하지 않습니다.',
	'animationNoExitText': '위젯이 장면의 끝 부분에 있으면 종료 애니메이션이 발생하지 않습니다.',
	'propAniTypeDataEntrance': '데이터 시작',
	'propAniRevealDuration': '시작 애니메이션 지속 기간',
	'timelineAnimationProperties': '애니메이션 특성 열기',
	'scenesPropertiesSection': '장면',
	'editStoryCoachMarkTitle': '스토리 편집',
	'editStoryCoachMarkContents': '이 스토리를 편집하려면 연필 아이콘을 클릭하십시오.',
	'addDataStoryCoachMarkContents': '데이터 패널의 데이터를 끌어서 스토리에 놓으십시오.',
	'expandSceneCoachmarkTitle': '타임라인 열기',
	'expandSceneCoachmarkContents': '시간 및 지속 기간을 기반으로 오브젝트 가시성을 적용하여 장면을 애니메이트하십시오.',
	'overviewCoachmarkTitle': '개요 장면',
	'overviewCoachmarkContents': '스토리의 시작 및 마지막에서 개요 장면을 사용하여 모든 장면의 큰 그림을 표시하십시오. 개요 장면에서 장면을 클릭하여 끌어와 다른 장면으로 교환하십시오. 스토리 특성에서 개요 장면을 표시하거나 숨길 수 있습니다.',
	'animatedPathCoachmarkTitle': '애니메이션 경로',
	'animatedPathCoachmarkContents': '오브젝트를 하나의 장면에서 다른 장면으로 애니메이션화하려면 오브젝트가 있는 장면을 복제하십시오. 그리고 새 장면에서 복제된 오브젝트를 이동, 크기 조정하거나 회전하십시오.',
	'propShowStoryOverviewFirstSlide': '시작 시 모든 장면 표시',
	'propShowStoryOverviewLastSlide': '종료 시 모든 장면 표시',
	'storySceneSingleCountLabel': '장면 1',
	'storySceneCountLabel': '%{count}개의 장면',
	'storySceneRangeCountLabel': '%{index}/%{count} 장면',
	'storySceneExpand': '타임라인 열기',
	'storySceneActionMenu': '시작 장면 옵션 메뉴',
	'timelineRightContainerLabel': '타임라인 단추 제어 그룹',
	'timelineViewLabel': '타임라인',
	'timelineZoomFit': '화면 크기에 맞게',
	'timelineZoomIn': '확대',
	'timelineZoomOut': '축소',
	'timelinePositionIndicator': '%{position}의 타임라인 위치 표시기',
	'timelinePositionIndicatorMoveLeftTo': '타임라인 위치 표시기가 %{position} 왼쪽으로 이동',
	'timelinePositionIndicatorMoveRightTo': '타임라인 위치 표시기가 %{position} 오른쪽으로 이동',
	'sceneStart': '%{position}(으)로 장면 시작 부분으로 이동',
	'sceneEnd': '%{position}(으)로 장면 끝 부분으로 이동',
	'timelineHighlightTitle': '강조표시',
	'addTimelineHighlight': '강조표시 추가',
	'addSceneBtnTitle': '기본 템플리트로 새 장면 추가',
	'addSceneChevronBtnTitle': '장면 템플리트 선택',
	'timelinePlay': '재생',
	'timelinePause': '일시정지',
	'sceneNavigation': '장면 탐색',
	'navNextScene': '다음 장면',
	'navPrevScene': '이전 장면',
	'navPrevSceneAbbreviated': '이전 장면',
	'navExitFullScreen': '전체 화면 종료',
	'navToggleOverview': '개요 전환',
	'rowNumber': '%{number}행',
	'overviewBtnLabel': '개요',
	'sceneListStart': '개요 시작',
	'sceneListEnd': '개요 종료',
	'timelineLeftHandle': '%{name}에 대한 왼쪽 핸들',
	'timelineRightHandle': '%{name}에 대한 오른쪽 핸들',
	'timelineLeftHandleNoTitle': '왼쪽 핸들',
	'timelineRightHandleNoTitle': '오른쪽 핸들',
	'timelineMoveLeft': '%{object} 왼쪽으로 이동',
	'timelineMoveRight': '%{object} 오른쪽으로 이동',
	'timelineMoveWidget': '타임라인 위젯이 %{newStartTime} 및 %{newEndTime}(으)로 이동됨',
	'timelineMoveWidgetStartTime': '타임라인 위젯 시작 시간이 %{newStartTime}(으)로 변경됨',
	'timelineMoveWidgetEndTime': '타임라인 종료 시간이 %{newEndTime}(으)로 변경됨',
	'timelineMoveWidgetDown': '타임라인 위젯이 아래로 이동됨',
	'timelineMoveWidgetUp': '타임라인 위젯이 위로 이동됨',
	'addSceneTitle': '장면 추가',
	'blankSceneLayout': '공백',
	'titleSceneLayout': '하위 제목이 있는 제목',
	'sceneLayout1': '하나의 시각화 옆에 텍스트가 있는 제목',
	'sceneLayout2': '하나의 시각화가 있는 제목',
	'sceneLayout3': '두 개의 시각화가 있는 제목',
	'sceneLayout4': '다목적',
	'sceneLayout5': '하나의 시각화 옆에 텍스트가 있는 제목 없음',
	'sceneLayout6': '다목적 2x2',
	'sceneLayout7': '다목적 2+1',
	'sceneLayout8': '다목적 1+2',
	'sceneLayout9': '다목적 1/2',
	'sceneLayout10': '다목적 2/1',
	'sceneLayout11': '다목적 4/1',
	'sceneLayout12': '다목적 1/1+2x2/1',
	'titleWidgetPlaceholderText': '여기에 제목 입력',
	'subtitleWidgetPlaceholderText': '여기에 하위 제목 입력',
	'createStoryViewTitle': '스토리 작성',
	'defaultStoryName': '새 스토리',
	'screenshot_label': '%{title} 스토리',
	'screenshot_label_scene': '%{title} 스토리의 %{sceneTitle} 장면',
	'filmstripHandleOpenLabel': '장면 선택기 열기',
	'filmstripHandleCloseLabel': '장면 선택기 닫기'
});
